import CalendarView from '../modules/mechanic/Workshop/Calendar/CalendarView';

/**
 * Schedule — the full calendar, promoted out of the Workshop tabs into its own
 * top-level page. The dashboard's Appointments column links here via
 * "View full calendar".
 */
export default function SchedulePage() {
    return (
        <div className="p-4 lg:p-0">
            <div className="mb-6">
                <h1 className="text-3xl font-display font-bold text-fg max-md:text-2xl tracking-tight">
                    Schedule
                </h1>
                <p className="text-fg-3 text-sm">Your calendar of appointments.</p>
            </div>
            <CalendarView />
        </div>
    );
}
